function filterShopifyEvent(event, domElement, callback) {
    let executeCallback = false;
    if (event.type.includes('shopify:section')) {
        if (domElement.hasAttribute('data-section-id') && domElement.getAttribute('data-section-id') === event.detail.sectionId) executeCallback = true
    } else if (event.type.includes('shopify:block') && event.target === domElement) { 
        executeCallback = true 
    }
    if (executeCallback) callback(event)
}

// is in viewport
function inViewport(elem, callback, options = {}) {
    return new IntersectionObserver(entries => {
        entries.forEach(entry => callback(entry))
    }, options).observe(document.querySelector(elem));
}

/* How to inViewport
document.addEventListener("DOMContentLoaded", () => {
    inViewport('[data-inviewport]', element => {
        if (!element.isIntersecting) { document.querySelector('#add2cart-cta').classList.add('active') } 
        else { document.querySelector('#add2cart-cta').classList.remove('active') }
    });
});
*/

// Toggle Body Class
let toggleBodyClass = function(arg) { 
    document.body.classList.toggle(arg);
}
// Get Element Height
function getElementHeight(targetElement,appendTo,cssVar) {
    let element = document.querySelector(targetElement);

    if (element) {
        let elementHeight = element.offsetHeight;
        document.querySelector(appendTo).style.setProperty(cssVar, `${elementHeight}px`);
    }
}

// first we get the viewport height and we multiple it by 1% to get a value for a vh unit
const getSetVh = () => { const roundedVh = Math.round(window.innerHeight * 0.01); document.body.style.setProperty('--vh', `${roundedVh}px`) };
window.addEventListener('resize', getSetVh);

// Browser check
function getNavigator() {
    const isiOS = navigator.userAgent.match(/(iPhone|iPad|iPod)/) && navigator.userAgent.match(/AppleWebKit/) && !navigator.userAgent.match(/CriOS/);
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) || Object.prototype.toString.call(window.HTMLElement).indexOf('Constructor') > 0 || navigator.userAgent.indexOf('Safari') != -1 && navigator.userAgent.indexOf('Chrome') == -1;
    const isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime) || navigator.userAgent.indexOf('Chrome') != -1;
    const isFirefox = typeof InstallTrigger !== 'undefined' || navigator.userAgent.indexOf('Firefox') != -1;
    const isEdge = !!window.StyleMedia || navigator.userAgent.indexOf('Edge') != -1

    if (isiOS) document.documentElement.classList.add('ios');
    if (isSafari) document.documentElement.classList.add('safari');
    if (isChrome) document.documentElement.classList.add('chrome');
    if (isFirefox) document.documentElement.classList.add('firefox');
    if (isEdge) document.documentElement.classList.add('edge');
}

// Toggle
    let toggleClass = function(qSelectors, bodyClass) {   
        document.querySelectorAll(qSelectors).forEach(e => e.addEventListener('click', () => toggleBodyClass(bodyClass)))
    }
// Menu
    let toggleMenu = function() { 
        toggleClass('.fire-menu, .shrink-menu', 'open-menu')
    }


    function initializeDetailsControls() {
        // Handle dropdown menu
        const detailsElementsLv1 = document.querySelectorAll('details.lv1');
        const detailsElementsClosex = [...document.querySelectorAll('details.closex')];
    
        function closeOtherDetails(element) {
            const detailsOpened = document.querySelectorAll('details[open].lv1');
            for (const item of detailsOpened) {
                if (element !== item) {
                    item.removeAttribute('open');
                }
            }
        }

        function closeAllDetailsExcept(target) {
            detailsElementsClosex.forEach(f => !f.contains(target) ? f.removeAttribute('open') : '');
            a11yDetails();
        }
    
        function closeAllDetails() {
            detailsElementsClosex.forEach(f => f.removeAttribute('open'));
            a11yDetails();
        }
    
        // Dropdown menu
        detailsElementsLv1.forEach(item => {
            item.addEventListener('click', function() {
                closeOtherDetails(this);
            });
        });
    
        // Close details when clicked outside
        document.addEventListener('click', function(e) {
            if (!detailsElementsClosex.some(f => f.contains(e.target))) {
                closeAllDetails();
            } else {
                closeAllDetailsExcept(e.target);
            }
        });
    
        // Close details with esc key
        document.addEventListener('keydown', function(e) {
            if (e.key === 'Escape' || e.keyCode === 27) {
                closeAllDetails();
            }
        });
    
        // Initial accessibility settings
        a11yDetails();
    }

    function a11yDetails() {
        document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
            summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));
            
            if(summary.nextElementSibling.getAttribute('id')) {
                summary.setAttribute('aria-controls', summary.nextElementSibling.id);
            }
            
            summary.addEventListener('click', (event) => {
                event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
            });
        });
    }
    

// update button price on variant change 
function updatePrice(obj,idd) {
    var uid = obj.options[obj.selectedIndex].getAttribute('data-price');
    var pb = document.querySelector('.uprice'+idd);
    pb.innerHTML = uid;
}

function selectOptions(obj,idd) { updatePrice(obj,idd) }

// Debug
if (window.location.href.includes('debug')) {
    const OpenThinking = { theme: { name: 'Bullet', version: Shopify.theme.schema_version } };
    const tsiCheck = (Shopify.theme.theme_store_id === null || Shopify.theme.theme_store_id === '') ? '❌' : '✅';
    console.log(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} - ${Shopify.shop}`);
    alert(`${tsiCheck} ${OpenThinking.theme.name} v${OpenThinking.theme.version} `);
}

// Bullet marquee
if (!customElements.get('bullet-marquee')) customElements.define('bullet-marquee', class bulletMarquee extends HTMLElement {
    constructor() { super(); if (window.ResizeObserver) new ResizeObserver(this.duration.bind(this)).observe(this); }

    duration(entries) {
        const scrollingSpeed = parseInt(this.getAttribute('bullet-speed') || 5);
        const contentWidth = entries[0].contentRect.width;
      
        // Calculate the slowFactor based on content width
        let slowFactor = contentWidth <= 375 ? 1 : contentWidth >= 1280 ? 3 : 1 + (contentWidth - 375) / (1280 - 375);

        // Calculate the scrolling speed with the adjusted slowFactor
        const scrollingDuration = (scrollingSpeed * slowFactor * entries[0].target.querySelector('span').clientWidth / contentWidth).toFixed(3);

        this.style.setProperty('--bullet-speed', `${scrollingDuration}s`);
    }
});

/*** init app */
function initApp() {
    getSetVh(); // get Viewport Height
    getNavigator(); // get the browser + OS
    toggleMenu(); // toggle Menu
    initializeDetailsControls(); // call details 
}

/*** on DOM ready **/
document.addEventListener("DOMContentLoaded", () => { initApp() })

document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('#ajaxSection');
  const hasPriceInputs =
    document.getElementById('customPriceSlider-minor') || document.getElementById('priceSlider-minor');
  const hasLegacyFilterInputs =
    document.querySelector('#FacetFiltersFormMobile input[name="filter-availability"]') ||
    document.querySelector('#FacetFiltersFormMobile input[name="filter-gender"]');
  const hasCollectionGenderTabs = document.querySelector('.listing-page .gender-btn');

  if (!container || (!hasPriceInputs && !hasLegacyFilterInputs && !hasCollectionGenderTabs)) {
    return;
  }

  const products = () => container.querySelectorAll('.pro-card:not(.custom-hide)');
  const availabilityChecks = () => document.querySelectorAll('input[name="filter-availability"]:checked');

  function parseMoneyToCents(raw, fallbackCents) {
    if (raw === '' || raw == null) return fallbackCents;
    const n = parseFloat(String(raw).replace(/,/g, ''));
    if (Number.isNaN(n)) return fallbackCents;
    return Math.round(n * 100);
  }

  function getPriceSliderMaxCents() {
    const el = document.getElementById('customPriceSlider') || document.getElementById('priceSlider');
    if (!el) return 200 * 100;
    const maxAttr = el.getAttribute('max');
    if (!maxAttr) return 200 * 100;
    const n = parseFloat(String(maxAttr).replace(/,/g, ''));
    return Number.isNaN(n) ? 200 * 100 : Math.round(n * 100);
  }

  function getPriceRange() {
    const minorEl =
      document.getElementById('customPriceSlider-minor') || document.getElementById('priceSlider-minor');
    const majorEl =
      document.getElementById('customPriceSlider-major') || document.getElementById('priceSlider-major');
    const sliderEl =
      document.getElementById('customPriceSlider') || document.getElementById('priceSlider');

    const maxDefaultCents = getPriceSliderMaxCents();
    let minCents = parseMoneyToCents(minorEl && minorEl.value, null);
    let maxCents = parseMoneyToCents(majorEl && majorEl.value, null);

    if (minCents === null && sliderEl && sliderEl.getAttribute('value1') != null) {
      minCents = parseMoneyToCents(sliderEl.getAttribute('value1'), 0);
    }
    if (maxCents === null && sliderEl && sliderEl.getAttribute('value2') != null) {
      maxCents = parseMoneyToCents(sliderEl.getAttribute('value2'), maxDefaultCents);
    }
    if (minCents === null) minCents = 0;
    if (maxCents === null) maxCents = maxDefaultCents;

    return { min: minCents, max: maxCents };
  }

  function findGenderDetailsInForm() {
    const form = document.getElementById('FacetFiltersFormMobile');
    if (!form) return null;
    let details = form.querySelector('details[data-theme-gender-facet="true"]');
    if (details) return details;
    const list = form.querySelectorAll('details.dm.closex');
    for (let i = 0; i < list.length; i++) {
      const sm = list[i].querySelector('summary');
      if (sm && sm.textContent.toLowerCase().indexOf('gender') !== -1) return list[i];
    }
    return null;
  }

  function getNativeGenderFacetBuckets() {
    const details = findGenderDetailsInForm();
    if (!details) return [];
    const buckets = [];
    details.querySelectorAll('input[type="checkbox"][name^="filter."]:checked').forEach((inp) => {
      if (inp.disabled) return;
      const v = (inp.value || '').toLowerCase().trim();
      if (/wom|female|wmns|wmn/.test(v)) buckets.push('womens');
      else if (/men|male|^man$|mens/.test(v)) buckets.push('mens');
      else {
        const lab = inp.closest('label');
        const t = ((lab && lab.textContent) || '').toLowerCase();
        if (/wom|female|wmns|wmn/.test(t)) buckets.push('womens');
        else if (/\bmen\b|male|mens|\bman\b/.test(t)) buckets.push('mens');
      }
    });
    return [...new Set(buckets)];
  }

  function genderFacetSectionHasNoSelection() {
    const details = findGenderDetailsInForm();
    if (!details) return false;
    const inputs = details.querySelectorAll('input[type="checkbox"][name^="filter."]');
    if (!inputs.length) return false;
    return details.querySelectorAll('input[type="checkbox"][name^="filter."]:checked').length === 0;
  }

  function getEffectiveGenderBuckets() {
    const legacy = [...document.querySelectorAll('input[name="filter-gender"]:checked')].map((c) => c.value);
    if (legacy.length) return [...new Set(legacy)];
    const native = getNativeGenderFacetBuckets();
    if (native.length) return native;
    if (genderFacetSectionHasNoSelection()) return [];
    const tabBtn = document.querySelector('.listing-page .gender-btn.active');
    const t = tabBtn && tabBtn.getAttribute('data-gender');
    if (t && t !== 'all') return [t];
    return [];
  }

  function cardMatchesGenderRules(card) {
    const g = card.getAttribute('data-gender') || '';
    if (!g) return true;
    const buckets = getEffectiveGenderBuckets();
    if (!buckets.length) return true;
    return (
      buckets.includes(g) ||
      (g === 'both' && (buckets.includes('mens') || buckets.includes('womens')))
    );
  }

  function applyFilters() {
    const availValues = [...availabilityChecks()].map(c => c.value === 'in-stock');
    const { min: priceMin, max: priceMax } = getPriceRange();

    products().forEach((card) => {
      let show = true;

      if (availValues.length) {
        const inStock = card.getAttribute('prod-instock') === 'true';
        const wantInStock = availValues.includes(true);
        const wantOutOfStock = availValues.includes(false);
        if ((wantInStock && !inStock) || (wantOutOfStock && inStock)) show = false;
      }

      if (show) {
        const price = parseInt(card.getAttribute('data-price'), 10) || 0;
        if (price < priceMin || price > priceMax) show = false;
      }

      if (show && !cardMatchesGenderRules(card)) show = false;

      card.style.display = show ? '' : 'none';
    });
  }

  window.themeCollectionApplyCustomFilters = applyFilters;

// Applies filters only when Apply button clicked
const filterForm = document.getElementById('FacetFiltersFormMobile');
if (filterForm) {
  filterForm.addEventListener('submit', function(e) {
    e.preventDefault();
    applyFilters();
    
    const { min: priceMin, max: priceMax } = getPriceRange();
    const SLIDER_MAX = getPriceSliderMaxCents();
    const hasPriceFilter = priceMin > 0 || priceMax < SLIDER_MAX;
    const hasCheckboxFilters = document.querySelectorAll('#FacetFiltersFormMobile input[name^="filter-"]:checked').length > 0;
    const hasCustomFilters = hasCheckboxFilters || hasPriceFilter;

    const sortSelect = document.getElementById('sort_by');
    if (!hasCustomFilters && sortSelect) {
      const newSort = sortSelect.value;
      const url = new URL(window.location.href);
      if (url.searchParams.get('sort_by') !== newSort) {
        url.searchParams.set('sort_by', newSort);
        window.location.href = url.toString();
      }
    }
  });
}

  // Re-apply when products are added (InfiniScroll); 
  if (container) {
    new MutationObserver(applyFilters).observe(container, { childList: true });
  }
});


/* After PDP “Buy now”: checkout uses a one-line cart; restore the pre-checkout cart when the customer returns. */
function themeCartAddJsUrl() {
  const u = (window.routes && window.routes.cart_add_url) || '/cart/add';
  return u.indexOf('.js') !== -1 ? u : `${u.replace(/\/+$/, '')}.js`;
}

function themeRefreshLiquidAjaxCart() {
  const run = () => {
    if (window.liquidAjaxCart && typeof window.liquidAjaxCart.get === 'function') {
      window.liquidAjaxCart.get();
      return true;
    }
    return false;
  };
  if (run()) return;
  const t0 = Date.now();
  const id = setInterval(() => {
    if (run() || Date.now() - t0 > 8000) clearInterval(id);
  }, 50);
  document.addEventListener(
    'liquid-ajax-cart:init',
    () => {
      run();
      clearInterval(id);
    },
    { once: true }
  );
}

let themeBuyNowRestoreInFlight = false;

function themeBuyNowCartRestoreRun() {
  const PENDING = 'theme_buy_now_restore_pending';
  const BACKUP = 'theme_buy_now_cart_backup';
  const MAX_AGE_MS = 24 * 60 * 60 * 1000;

  if (themeBuyNowRestoreInFlight) return;
  if (sessionStorage.getItem(PENDING) !== '1') return;

  let payload;
  try {
    payload = JSON.parse(sessionStorage.getItem(BACKUP) || '{}');
  } catch (e) {
    sessionStorage.removeItem(PENDING);
    sessionStorage.removeItem(BACKUP);
    return;
  }

  const items = payload.items;
  if (!items || !items.length) {
    sessionStorage.removeItem(PENDING);
    sessionStorage.removeItem(BACKUP);
    return;
  }
  if (payload.ts && Date.now() - payload.ts > MAX_AGE_MS) {
    sessionStorage.removeItem(PENDING);
    sessionStorage.removeItem(BACKUP);
    return;
  }

  const clearUrl = window.routes && window.routes.cart_clear_url;
  if (!clearUrl) return;

  themeBuyNowRestoreInFlight = true;

  const headers = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  fetch(clearUrl, { method: 'POST', headers, body: '{}' })
    .then((res) => {
      if (!res.ok) throw new Error('Cart clear failed');
      return fetch(themeCartAddJsUrl(), {
        method: 'POST',
        headers,
        body: JSON.stringify({ items }),
      });
    })
    .then((res) => {
      if (!res.ok) throw new Error('Cart restore failed');
      return res.json();
    })
    .then(() => {
      sessionStorage.removeItem(PENDING);
      sessionStorage.removeItem(BACKUP);
      themeRefreshLiquidAjaxCart();
    })
    .catch((err) => console.error('themeBuyNowCartRestore', err))
    .finally(() => {
      themeBuyNowRestoreInFlight = false;
    });
}

document.addEventListener('DOMContentLoaded', themeBuyNowCartRestoreRun);
window.addEventListener('pageshow', (event) => {
  if (event.persisted) themeBuyNowCartRestoreRun();
});